import { en, type MessageKey } from './en.ts';
import { enUS } from './en-US.ts';

export type { MessageKey };

export const LOCALE = 'en-GB';
export const LOCALE_US = 'en-US';

export type Region = 'uk' | 'us' | 'none';

let currentRegion: Region = 'uk';
export const setMessageRegion = (next: Region) => {
  currentRegion = next;
};
export const region = (): Region => currentRegion;
export const locale = () => (currentRegion === 'us' ? LOCALE_US : LOCALE);

const message = (key: MessageKey): string => (currentRegion === 'us' ? enUS[key] : undefined) ?? en[key];

export function t(key: MessageKey, vars?: Readonly<Record<string, string | number>>): string {
  const template = message(key);
  if (!vars) return template;
  return template.replace(/\{(\w+)\}/g, (match, name: string) => (name in vars ? String(vars[name]) : match));
}

/** A message with each `{name}` placeholder handed to `render`, for copy that styles its variables. */
export function tParts<T>(key: MessageKey, vars: Readonly<Record<string, string | number>>, render: (value: string, name: string) => T): (string | T)[] {
  return message(key).split(/(\{\w+\})/).filter(Boolean).map((part) => {
    const name = /^\{(\w+)\}$/.exec(part)?.[1];
    return name && name in vars ? render(String(vars[name]), name) : part;
  });
}
